// Local (browser) persistence helpers for cookie consent.
const STORAGE_KEY = "cookie_consent_preferences";
export const FALLBACK_VERSION = "1.0.0";

export function sameConsent(a, b) {
  if (!a || !b) return false;
  return (
    a.first_party === b.first_party &&
    a.third_party === b.third_party &&
    a.consent_version === b.consent_version
  );
}

export function readStoredConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (typeof parsed?.first_party !== "boolean" || typeof parsed?.third_party !== "boolean") {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function persistConsent(consent) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
}
